<div class="PageContent">

    <!-- <div class="overlay" *ngIf="showAddNewConfiguration;"></div> -->
    <div class="overlayTransparent animated fadeIn" *ngIf="this.SearchedProducts?.length > 0 || ShowFilter == true;" (click)="CloseOverlay();"></div>
    <div class="overlay animated fadeIn" *ngIf="ShowDeleteConfigurationOffers || ShowUpdateGroupDiscountsData || ShowDiscountGroupDelete || AskImportQuestionPopUp || AskOfferingImportQuestionPopUp" (click)="CloseImportOverlay();" style="z-index: 202;" (click)="AskImportQuestionPopUp = false;"></div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteConfigurationOffers">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDeleteConfigurationOffers = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteConfigurationOffers = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteConfigurationOffers = false; DeleteImportConfigurationOffers();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowUpdateGroupDiscountsData">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowUpdateGroupDiscountsData = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'UpdatePricesBasedOnGroupData' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'UpdatePricesBasedOnGroupDataDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowUpdateGroupDiscountsData = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowUpdateGroupDiscountsData = false; UpdateGroupDiscountsData();">
          <i class="material-icons">downloading</i>
          {{ 'UpdateData' | translate }}
        </button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDiscountGroupDelete">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="ShowDiscountGroupDelete = false;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'Configuration.DeleteQuestion' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDiscountGroupDelete = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDiscountGroupDelete = false; RemoveDiscountGroup(this.CurrentDiscountGroup);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="AskImportQuestionPopUp">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="AskImportQuestionPopUp = false; CurrentTask = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'DataImportWarning' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'DataImportWarningDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="AskImportQuestionPopUp = false; CurrentTask = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="AskImportQuestionPopUp = false; GetProductsFromConfiguration();">
          <i class="material-icons">downloading</i>
          {{ 'ImportData' | translate }}
        </button>
      </div>
    </div>

    <div class="InfoQuestion animated fadeInDown" *ngIf="AskOfferingImportQuestionPopUp">
      <div class="InfoQuestionClose">
        <i class="material-icons" (click)="AskOfferingImportQuestionPopUp = false; CurrentTask = null;">close</i>
      </div>
      <div class="InfoQuestionTitle">
        {{ 'DataImportWarning' | translate }}
      </div>
      <div class="InfoQuestionBody">
        {{ 'DataImportWarningDescription' | translate }}
      </div>
  
      <div class="InfoQuestionCommands">
        <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="AskOfferingImportQuestionPopUp = false; CurrentTask = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
        <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="AskOfferingImportQuestionPopUp = false; DeletePreviousData = true; GetProductsOfferingData();">
          <i class="material-icons">downloading</i>
          {{ 'ImportOfferingData' | translate }}
        </button>

        <mat-slide-toggle style="margin-left: 5%;" [(ngModel)]="this.UseParallelism">
          <span *ngIf="this.UseParallelism" matTooltip="{{ 'FastDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>!!!{{'Fast' | translate}}</span>
          <span *ngIf="!this.UseParallelism">{{'Slow' | translate}}</span>
        </mat-slide-toggle>
      </div>
    </div>

    <!-- <div class="NewProductContainer animated fadeInDown" *ngIf="showAddNewConfiguration == true;">
        <div class="NewProductContainerTitleBar">
          <p *ngIf="this.Configuration.ID == 0;">{{'NewConfiguration' | translate}}</p>
          <p *ngIf="this.Configuration.ID > 0;">{{'ModifyConfiguration' | translate}}: {{this.Configuration.Name}}</p>
          <i class="material-icons" (click)="showAddNewConfiguration = false; this.Configuration = null;">close</i>
        </div>
        <div class="NewProductContainerBody">
          <div class="TwoThirdsColumn">
  
            <div class="ColumnTitle">
              <i class="material-icons">radio_button_checked</i>
              {{'GeneralInformation' | translate}}
            </div>
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Name' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Name' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.Name">
            </mat-form-field>
  
            <mat-form-field class="BrandSelectContainer" appearance="outline">
                <mat-label>{{'ChoosePartner' | translate}}*</mat-label>
                <input class="BrandSelect"
                       type="text"
                       placeholder="{{'ChoosePartner' | translate}}"
                       matInput
                       [matAutocomplete]="auto1"
                       [(ngModel)]="this.Configuration?.Partner.Name"
                       (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                       (click)="InitializePartners();">
                <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Partner?.Name?.length > 0;" (click)="ClearPartnerBrand();">close</i>
                <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Configuration.Partner?.Name?.length > 0) != true;">search</i>
                <mat-autocomplete #auto1="matAutocomplete">
                  <mat-option *ngFor="let p of Partners" [value]="p" (click)="this.Configuration.Partner = p;">
                    {{p.Name}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

            <mat-form-field class="BrandSelectContainer" appearance="outline">
              <mat-label>{{'SelectBrand' | translate}}*</mat-label>
              <input class="BrandSelect"
                     type="text"
                     placeholder="{{'SelectBrand' | translate}}"
                     matInput
                     [matAutocomplete]="auto"
                     [(ngModel)]="this.Configuration?.Brand.Name"
                     (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                     (click)="InitializeBrands();">
              <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Brand?.Name?.length > 0;" (click)="ClearSearchBrand();">close</i>
              <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Configuration.Brand?.Name?.length > 0) != true;">search</i>
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Configuration.Brand = brand;">
                  {{brand.Name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Creator' | translate }}*</mat-label>
              <input disabled="true" matInput placeholder="{{ 'Creator' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.CreatingUser.UIName">
            </mat-form-field>
  
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'UpdateingUser' | translate }}*</mat-label>
              <input disabled="true" matInput placeholder="{{ 'UpdateingUser' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.UpdatingUser.UIName">
            </mat-form-field>

            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.LeadTimeTypeTargetOutput?.Name?.length > 0;" (click)="this.Configuration.LeadTimeTypeTargetOutput = null;">close</i>
                <mat-label>{{ 'LeadTimeTypeTargetOutput' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.LeadTimeTypeTargetOutput != null" name="LeadTimeTypeTargetOutput" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.LeadTimeTypeTargetOutput">
                  <mat-option *ngFor="let t of this.LeadTimeTypes" [value]="t">
                    {{t.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
              <mat-slide-toggle matTooltip="{{ 'ProlongedLeadTimeDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.Configuration.ProlongedLeadTime">{{'ProlongedLeadTime' | translate}}</mat-slide-toggle>
            </div>

            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.LeadTimePriorityStrategy?.Name?.length > 0;" (click)="this.Configuration.LeadTimePriorityStrategy = null;">close</i>
                <mat-label>{{ 'LeadTimePriorityStrategy' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.LeadTimePriorityStrategy != null" name="LeadTimePriorityStrategy" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.LeadTimePriorityStrategy">
                  <mat-option *ngFor="let s of this.LeadTimePriorityStrategies" [value]="s">
                    {{s.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.LeadTimeType?.Name?.length > 0;" (click)="this.Configuration.LeadTimeType = null;">close</i>
                <mat-label>{{ 'LeadTimeType' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.LeadTimeType != null" name="LeadTimeType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.LeadTimeType">
                  <mat-option *ngFor="let t of this.LeadTimeTypes" [value]="t">
                    {{t.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle class="IsWorkDaysCheck" *ngIf="this.Configuration.LeadTimeType != null" [(ngModel)]="this.Configuration.LeadTimeType.IsWorkDays">{{'IsWorkDays' | translate}}</mat-slide-toggle>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Currency?.Name?.length > 0;" (click)="this.Configuration.Currency = null;">close</i>
                <mat-label>{{ 'Currency' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Currency != null" name="Currency" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.Currency">
                  <mat-option *ngFor="let c of this.parent.masterData.Currencies" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.WeightMeasurementType?.Name?.length > 0;" (click)="this.Configuration.WeightMeasurementType = null;">close</i>
                <mat-label>{{ 'WeightMeasurementType' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.WeightMeasurementType != null" name="WeightMeasurementType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.WeightMeasurementType">
                  <mat-option *ngFor="let w of this.WeightMeasurementTypes" [value]="w">
                    {{w.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'FixedDiscount' | translate }}*</mat-label>
                <input matInput placeholder="{{ 'FixedDiscount' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.FixedDiscount">
            </mat-form-field>

            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'MinimumOrderAmmount' | translate }}*</mat-label>
                <input matInput placeholder="{{ 'MinimumOrderAmmount' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.MinimumOrderAmmount">
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.ConfigImportCategory?.Name?.length > 0;" (click)="this.Configuration.ConfigImportCategory = null;">close</i>
                <mat-label>{{ 'ConfigImportCategory' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.ConfigImportCategory != null" name="ConfigImportCategory" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.ConfigImportCategory">
                  <mat-option *ngFor="let c of this.ConfigImportCategories" [value]="c">
                    {{c.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'ServerPath' | translate }}*</mat-label>
                <input matInput placeholder="{{ 'ServerPath' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.ServerPath">
            </mat-form-field>

            <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle [(ngModel)]="this.Configuration.ImportFromServerPath">{{'ImportFromServerPath' | translate}}</mat-slide-toggle>
            </div>

            <mat-form-field class="BrandSelectContainer" appearance="outline" matTooltip="{{ 'ConfigurationWarehouseDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <mat-label>{{'SelectWarehouse' | translate}}</mat-label>
              <input id="warehouseselectid" class="BrandSelect"
                     type="text"
                     placeholder="{{'SelectWarehouse' | translate}}"
                     matInput
                     [matAutocomplete]="auto2"
                     [(ngModel)]="this.Configuration?.Warehouse.Name"
                     (ngModelChange)="this.warehouseSearchTermUpdate.next($event)"
                     (click)="InitializeWarehouses();">
              <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Warehouse?.Name?.length > 0;" (click)="ClearSearchWarehouse();">close</i>
              <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Configuration.Warehouse?.Name?.length > 0) != true;">search</i>
              <mat-autocomplete #auto2="matAutocomplete">
                <mat-option *ngFor="let warehouse of this.Warehouses" [value]="warehouse" (click)="this.Configuration.Warehouse = warehouse;">
                  {{warehouse.Name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
              <mat-slide-toggle matTooltip="{{ 'MasterDataImportOnlyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.Configuration.MasterDataImportOnly">{{'MasterDataImportOnly' | translate}}</mat-slide-toggle>
            </div>

            <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
              <mat-slide-toggle matTooltip="{{ 'IdentifyProductsWithoutBrandDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.Configuration.IdentifyProductsWithoutBrand">{{'IdentifyProductsWithoutBrand' | translate}}</mat-slide-toggle>
            </div>

            <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
              <mat-slide-toggle [(ngModel)]="this.Configuration.UseGroupDiscounts">{{'UseGroupDiscounts' | translate}}</mat-slide-toggle>
            </div>

            <div class="DiscountGroupContainer">
              <button mat-raised-button color="primary" class="AddNewProductButton" (click)="InitializeNewDiscountGroup();">
                <i class="material-icons">add</i>
                {{'NewDiscountGroup' | translate}}
              </button>

              <div class="DiscountGroup" *ngFor="let discountGroup of this.Configuration.DiscountedGroups">
                <mat-form-field appearance="outline" class="ProductPropertyTextBox" style="width: 30%;">
                  <mat-label>{{ 'DiscountValue' | translate }}*</mat-label>
                  <input matInput placeholder="{{ 'DiscountValue' | translate }}*" autocomplete="off" [(ngModel)]="discountGroup.DiscountValue">
                </mat-form-field>
                
                <mat-form-field appearance="outline" class="ProductPropertyTextBox" style="width: 60%;">
                  <mat-label>{{ 'GroupName' | translate }}*</mat-label>
                  <input matInput placeholder="{{ 'GroupName' | translate }}*" autocomplete="off" [(ngModel)]="discountGroup.GroupName">
                </mat-form-field>

                <i class="material-icons discountGroupControlButton" (click)="RemoveDiscountGroup(discountGroup);">close</i>
              </div>
            </div>

          </div>
  
          <div class="OneThirdColumn">
  
            <div class="ColumnTitle">
              <i class="material-icons">format_list_bulleted</i>
              {{'Indexes' | translate}}
            </div>
  
            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Brand?.Name?.length > 0;" (click)="this.Configuration.Indexes.Brand = null;">close</i>
                <mat-label>{{ 'BrandIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.Brand != null" name="BrandIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Brand">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Name?.Name?.length > 0;" (click)="this.Configuration.Indexes.Name = null;">close</i>
                <mat-label>{{ 'NameIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.Name != null" name="NameIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Name">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.PartNumber?.Name?.length > 0;" (click)="this.Configuration.Indexes.PartNumber = null;">close</i>
              <mat-label>{{ 'PartNumberIndex' | translate }}</mat-label>
              <mat-select [disabled]="this.Configuration.Indexes.PartNumber != null" name="PartNumberIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.PartNumber">
                <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                  {{p.Name}}
                </mat-option>
              </mat-select>
          </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Description?.Name?.length > 0;" (click)="this.Configuration.Indexes.Description = null;">close</i>
                <mat-label>{{ 'DescriptionIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.Description != null" name="DescriptionIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Description">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Weight?.Name?.length > 0;" (click)="this.Configuration.Indexes.Weight = null;">close</i>
                <mat-label>{{ 'WeightIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.Weight != null" name="WeightIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Weight">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.WeightType?.Name?.length > 0;" (click)="this.Configuration.Indexes.WeightType = null;">close</i>
                <mat-label>{{ 'WeightTypeIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.WeightType != null" name="WeightTypeIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.WeightType">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.HSCode?.Name?.length > 0;" (click)="this.Configuration.Indexes.HSCode = null;">close</i>
                <mat-label>{{ 'HSCodeIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.HSCode != null" name="HSCodeIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.HSCode">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
            
            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Weight?.COO?.length > 0;" (click)="this.Configuration.Indexes.COO = null;">close</i>
                <mat-label>{{ 'COOIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.COO != null" name="COOIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.COO">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.EAN?.Name?.length > 0;" (click)="this.Configuration.Indexes.EAN = null;">close</i>
                <mat-label>{{ 'EANIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.EAN != null" name="EANIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.EAN">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.LeadTime?.Name?.length > 0;" (click)="this.Configuration.Indexes.LeadTime = null;">close</i>
                <mat-label>{{ 'LeadTimeIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.LeadTime != null" name="LeadTimeIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.LeadTime">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Price?.Name?.length > 0;" (click)="this.Configuration.Indexes.Price = null;">close</i>
                <mat-label>{{ 'PriceIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.Price != null" name="PriceIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Price">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.DiscountedPrice?.Name?.length > 0;" (click)="this.Configuration.Indexes.DiscountedPrice = null;">close</i>
                <mat-label>{{ 'DiscountedPriceIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.DiscountedPrice != null" name="DiscountedPriceIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.DiscountedPrice">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Currency?.Name?.length > 0;" (click)="this.Configuration.Indexes.Currency = null;">close</i>
                <mat-label>{{ 'CurrencyIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.Currency != null" name="CurrencyIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Currency">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.MOQ?.Name?.length > 0;" (click)="this.Configuration.Indexes.MOQ = null;">close</i>
                <mat-label>{{ 'MOQIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.MOQ != null" name="MOQIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.MOQ">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.DatasheetLink?.Name?.length > 0;" (click)="this.Configuration.Indexes.DatasheetLink = null;">close</i>
                <mat-label>{{ 'DatasheetLinkIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.DatasheetLink != null" name="DatasheetLinkIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.DatasheetLink">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.StockQuantity?.Name?.length > 0;" (click)="this.Configuration.Indexes.StockQuantity = null;">close</i>
                <mat-label>{{ 'StockQuantityIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.StockQuantity != null" name="StockQuantityIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.StockQuantity">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline"class="ProductPropertyTextBox">
              <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.DiscountGroup?.Name?.length > 0;" (click)="this.Configuration.Indexes.DiscountGroup = null;">close</i>
                <mat-label>{{ 'DiscountGroupIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.DiscountGroup != null" name="DiscountGroupIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.DiscountGroup">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

          </div>
        </div>
        <div class="NewProductContainerCommands">
          <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Configuration.ID == 0;" (click)="AddUpdateImportConfiguration();">
            <i class="material-icons">add</i>
            {{'NewConfiguration' | translate}}
          </button>
  
          <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Configuration.ID > 0;" (click)="AddUpdateImportConfiguration();">
            <i class="material-icons">edit</i>
            {{'ModifyConfiguration' | translate}}
          </button>
        </div>
    </div> -->

    <div class="PageContentTitle">
        <div class="PageContentTitleIntro">
            <i class="material-icons">save_alt</i>
            <p class="PageContentTitleParagraph">{{'DataImports' | translate}}</p>
        </div>

        <div class="TitleSearchInputContainer">
            <mat-form-field class="ButtonFilterDropDown" appearance="outline">
                <mat-label>{{'SearchConfiguration' | translate}}*</mat-label>
                <input class="BrandSelect"
                       type="text"
                       placeholder="{{'SearchConfiguration' | translate}}"
                       matInput
                       [matAutocomplete]="auto3"
                       [(ngModel)]="this.SearchTerm"
                       (ngModelChange)="this.searchTermUpdate.next($event)">
                <i style="height: 25px; line-height:25px;" class="material-icons BrandSelectCloseIcon">search</i>
                <mat-autocomplete #auto3="matAutocomplete">
                  <mat-option *ngFor="let c of ImportConfigurations" [value]="Configuration" (click)="GetImportConfigurationDetails(c);">
                    {{c.Name}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
        </div>

        <!-- <button *ngIf="this.Configuration?.ID > 0;" mat-raised-button color="accent" class="TitleFilterButton NewTaskButton" style="float:right;margin-right: 10px;" (click)="UpdateConfigurationPricesAndMOQ(this.Configuration);">
          {{'ReProofPriceData' | translate}}
          <i class="material-icons">refresh</i>
        </button> -->

        <button mat-raised-button color="primary" class="TitleFilterButton NewTaskButton" (click)="InitializeNewConfiguration();" style="float:right;margin-right: 10px;">
          {{'NewConfiguration' | translate}}
          <i class="material-icons">add</i>
        </button>
    </div>

    <div class="PageContentBody animated fadeIn">
        <div class="PageContentBodyTopCommands" *ngIf="this.Configuration?.ID > 0;">
           <div class="PageContentBodyTopCommandsTitle" *ngIf="this.Configuration?.ID > 0;">
             {{this.Configuration?.Name}}
           </div>

           <div class="PageContentBodyTopCommandsButtonContainer" style="float: left;">
            <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Configuration?.ID > 0;" (click)="AskOfferingImportQuestion();">
              <i class="material-icons">downloading</i>
              {{'ImportOfferingData' | translate}}
            </button>
           </div>

           <div class="PageContentBodyTopCommandsButtonContainer" style="float: left;">
            <mat-slide-toggle class="IsWorkDaysCheck" [(ngModel)]="this.Configuration.AutoImport"  matTooltip="{{ 'ConfigurationAutoImportDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'ConfigurationAutoImport' | translate}}</mat-slide-toggle>
           </div>

           <div class="PageContentBodyTopCommandsButtonContainer" style="float: left;">
            <mat-slide-toggle class="IsWorkDaysCheck" [(ngModel)]="this.Configuration.SpecialPriceList"  matTooltip="{{ 'SpecialPriceListDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'SpecialPriceList' | translate}}</mat-slide-toggle>
           </div>

           <div class="PageContentBodyTopCommandsButtonContainer">
            <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Configuration?.ID > 0;" (click)="CopyConfiguration();">
              <i class="material-icons">content_copy</i>
              {{'CopyConfiguration' | translate}}
            </button>
           </div>

           <div class="PageContentBodyTopCommandsButtonContainer">
              <input style="margin-top: 12.5px;" mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" *ngIf="this.Configuration?.ID > 0;">
           </div>
        </div>

        <div class="PageContentBodyTopCommands" *ngIf="this.Configuration?.ID == 0;">
          <div class="PageContentBodyTopCommandsTitle" *ngIf="this.Configuration?.ID > 0;">
            {{this.Configuration?.Name}}
          </div>

          <div class="PageContentBodyTopCommandsButtonContainer">
             <input style="margin-top: 12.5px;" mat-raised-button type="file" formControlName="UploadedFile" (change)="onSelectFile($event)" *ngIf="this.Configuration?.ID > 0;">
          </div>
       </div>

        <div class="PageContentBodyElementsContainer" *ngIf="this.Configuration?.ID != null;">
          <div class="NewProductContainerTitleBar">
            <p *ngIf="this.Configuration.ID == 0;">{{'NewConfiguration' | translate}}</p>
            <p *ngIf="this.Configuration.ID > 0;">{{'ModifyConfiguration' | translate}}: {{this.Configuration.Name}}</p>
            <i class="material-icons" (click)="showAddNewConfiguration = false; this.Configuration = null;">close</i>
          </div>
          <div class="NewProductContainerTitleBar">
            <mat-form-field appearance="outline" class="RankBox" matTooltip="{{ 'ConfigRankDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <mat-label>{{ 'Rank' | translate }}</mat-label>
              <input matInput name="Rank"
                [disabled]="!(this.Configuration.ID > 0)"
                inputmode="numeric"
                autocomplete="off"
                [(ngModel)]="this.Configuration.Rank"
                (keydown)="digitKeydown($event)"
                (paste)="digitPaste($event)"
                (drop)="digitDrop($event)"
                (input)="digitSanitize($event)"
                (wheel)="digitWheel($event)"/>
            </mat-form-field>

            <mat-form-field appearance="outline" class="RankBox" matTooltip="{{ 'LeadTimePenaltyDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <mat-label>{{ 'LeadTimePenalty' | translate }}</mat-label>
              <input matInput name="Rank"
                [disabled]="!(this.Configuration.ID > 0)"
                inputmode="numeric"
                autocomplete="off"
                [(ngModel)]="this.Configuration.LeadTimePenalty"/>
            </mat-form-field>

            <mat-form-field appearance="outline" class="RankBox" style="width: 30%;" matTooltip="{{ 'LeadTimeTypePenalityDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
              <i style="color: red; top:-15px;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.LeadTimeTypePenality?.Name?.length > 0;" (click)="this.Configuration.LeadTimeTypePenality = null;">close</i>
              <mat-label>{{ 'LeadTimeTypePenality' | translate }}</mat-label>
              <mat-select [disabled]="this.Configuration.LeadTimeTypePenality != null" name="LeadTimeTypePenality" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.LeadTimeTypePenality">
                <mat-option *ngFor="let t of this.LeadTimeTypes" [value]="t">
                  {{t.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="NewProductContainerBody">
            <div class="TwoThirdsColumn">
    
              <div class="ColumnTitle">
                <i class="material-icons">radio_button_checked</i>
                {{'GeneralInformation' | translate}}
              </div>

              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'ID' | translate }}*</mat-label>
                <input disabled="true" matInput placeholder="{{ 'ID' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.ID">
              </mat-form-field>

              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                  <mat-label>{{ 'Status' | translate }}</mat-label>
                  <mat-select [disabled]="!(this.Configuration.ID > 0)" name="ConfigStatus" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.ConfigStatus">
                    <mat-option *ngFor="let s of this.parent.masterData.ConfigStatuses" [value]="s">
                      {{s.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                  <mat-label>{{ 'NewProductsAcceptance' | translate }}</mat-label>
                  <mat-select [disabled]="!(this.Configuration.ID > 0)" name="NewProductsAcceptanceStatus" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.NewProductsAcceptanceStatus">
                    <mat-option *ngFor="let s of this.NewProductsAcceptanceStatuses" [value]="s">
                      {{s.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'Name' | translate }}*</mat-label>
                <input matInput placeholder="{{ 'Name' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.Name">
              </mat-form-field>
    
              <mat-form-field class="BrandSelectContainer" appearance="outline">
                  <mat-label>{{'ChoosePartner' | translate}}*</mat-label>
                  <input class="BrandSelect"
                         type="text"
                         placeholder="{{'ChoosePartner' | translate}}"
                         matInput
                         [matAutocomplete]="auto1"
                         [(ngModel)]="this.Configuration?.Partner.Name"
                         (ngModelChange)="this.partnerSearchTermUpdate.next($event)"
                         (click)="InitializePartners();">
                  <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Partner?.Name?.length > 0;" (click)="ClearPartnerBrand();">close</i>
                  <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Configuration.Partner?.Name?.length > 0) != true;">search</i>
                  <mat-autocomplete #auto1="matAutocomplete">
                    <mat-option *ngFor="let p of Partners" [value]="p" (click)="this.Configuration.Partner = p;">
                      {{p.Name}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
  
              <mat-form-field class="BrandSelectContainer" appearance="outline">
                <mat-label>{{'SelectBrand' | translate}}*</mat-label>
                <input class="BrandSelect"
                       type="text"
                       placeholder="{{'SelectBrand' | translate}}"
                       matInput
                       [matAutocomplete]="auto"
                       [(ngModel)]="this.Configuration?.Brand.Name"
                       (ngModelChange)="this.brandSearchTermUpdate.next($event)"
                       (click)="InitializeBrands();">
                <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Brand?.Name?.length > 0;" (click)="ClearSearchBrand();">close</i>
                <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Configuration.Brand?.Name?.length > 0) != true;">search</i>
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Configuration.Brand = brand;">
                    {{brand.Name}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
    
              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'Creator' | translate }}*</mat-label>
                <input disabled="true" matInput placeholder="{{ 'Creator' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.CreatingUser.UIName">
              </mat-form-field>
    
              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'UpdateingUser' | translate }}*</mat-label>
                <input disabled="true" matInput placeholder="{{ 'UpdateingUser' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.UpdatingUser.UIName">
              </mat-form-field>

              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.LeadTimeTypeTargetOutput?.Name?.length > 0;" (click)="this.Configuration.LeadTimeTypeTargetOutput = null;">close</i>
                  <mat-label>{{ 'LeadTimeTypeTargetOutput' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.LeadTimeTypeTargetOutput != null" name="LeadTimeTypeTargetOutput" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.LeadTimeTypeTargetOutput">
                    <mat-option *ngFor="let t of this.LeadTimeTypes" [value]="t">
                      {{t.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle matTooltip="{{ 'ProlongedLeadTimeDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.Configuration.ProlongedLeadTime">{{'ProlongedLeadTime' | translate}}</mat-slide-toggle>
              </div>

              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.LeadTimePriorityStrategy?.Name?.length > 0;" (click)="this.Configuration.LeadTimePriorityStrategy = null;">close</i>
                  <mat-label>{{ 'LeadTimePriorityStrategy' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.LeadTimePriorityStrategy != null" name="LeadTimePriorityStrategy" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.LeadTimePriorityStrategy">
                    <mat-option *ngFor="let s of this.LeadTimePriorityStrategies" [value]="s">
                      {{s.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.LeadTimeType?.Name?.length > 0;" (click)="this.Configuration.LeadTimeType = null;">close</i>
                  <mat-label>{{ 'LeadTimeType' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.LeadTimeType != null" name="LeadTimeType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.LeadTimeType">
                    <mat-option *ngFor="let t of this.LeadTimeTypes" [value]="t">
                      {{t.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
  
              <mat-slide-toggle class="IsWorkDaysCheck" *ngIf="this.Configuration.LeadTimeType != null" [(ngModel)]="this.Configuration.LeadTimeType.IsWorkDays">{{'IsWorkDays' | translate}}</mat-slide-toggle>
  
              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                <mat-label>{{ 'StandardLeadTimeUnits' | translate }}*</mat-label>
                <input matInput placeholder="{{ 'StandardLeadTimeUnits' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.StandardLeadTimeUnits">
              </mat-form-field>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Currency?.Name?.length > 0;" (click)="this.Configuration.Currency = null;">close</i>
                  <mat-label>{{ 'Currency' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Currency != null" name="Currency" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.Currency">
                    <mat-option *ngFor="let c of this.parent.masterData.Currencies" [value]="c">
                      {{c.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
  
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.WeightMeasurementType?.Name?.length > 0;" (click)="this.Configuration.WeightMeasurementType = null;">close</i>
                  <mat-label>{{ 'WeightMeasurementType' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.WeightMeasurementType != null" name="WeightMeasurementType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.WeightMeasurementType">
                    <mat-option *ngFor="let w of this.WeightMeasurementTypes" [value]="w">
                      {{w.Name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
  
              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                  <mat-label>{{ 'FixedDiscount' | translate }}*</mat-label>
                  <input matInput placeholder="{{ 'FixedDiscount' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.FixedDiscount">
              </mat-form-field>
  
              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                  <mat-label>{{ 'MinimumOrderAmmount' | translate }}*</mat-label>
                  <input matInput placeholder="{{ 'MinimumOrderAmmount' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.MinimumOrderAmmount">
              </mat-form-field>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.ConfigImportCategory?.Name?.length > 0;" (click)="this.Configuration.ConfigImportCategory = null;">close</i>
                  <mat-label>{{ 'ConfigImportCategory' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.ConfigImportCategory != null" name="ConfigImportCategory" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.ConfigImportCategory">
                    <mat-option *ngFor="let c of this.ConfigImportCategories" [value]="c">
                      {{c.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="ProductPropertyTextBox">
                  <mat-label>{{ 'ServerPath' | translate }}*</mat-label>
                  <input matInput placeholder="{{ 'ServerPath' | translate }}*" autocomplete="off" [(ngModel)]="this.Configuration.ServerPath">
              </mat-form-field>
  
              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                  <mat-slide-toggle [(ngModel)]="this.Configuration.ImportFromServerPath">{{'ImportFromServerPath' | translate}}</mat-slide-toggle>
              </div>
  
              <mat-form-field class="BrandSelectContainer" appearance="outline" matTooltip="{{ 'ConfigurationWarehouseDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
                <mat-label>{{'SelectWarehouse' | translate}}</mat-label>
                <input id="warehouseselectid" class="BrandSelect"
                       type="text"
                       placeholder="{{'SelectWarehouse' | translate}}"
                       matInput
                       [matAutocomplete]="auto2"
                       [(ngModel)]="this.Configuration?.Warehouse.Name"
                       (ngModelChange)="this.warehouseSearchTermUpdate.next($event)"
                       (click)="InitializeWarehouses();">
                <i class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Warehouse?.Name?.length > 0;" (click)="ClearSearchWarehouse();">close</i>
                <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.Configuration.Warehouse?.Name?.length > 0) != true;">search</i>
                <mat-autocomplete #auto2="matAutocomplete">
                  <mat-option *ngFor="let warehouse of this.Warehouses" [value]="warehouse" (click)="this.Configuration.Warehouse = warehouse;">
                    {{warehouse.Name}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
  
              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle matTooltip="{{ 'MasterDataImportOnlyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.Configuration.MasterDataImportOnly">{{'MasterDataImportOnly' | translate}}</mat-slide-toggle>
              </div>
  
              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle matTooltip="{{ 'IdentifyProductsWithoutBrandDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.Configuration.IdentifyProductsWithoutBrand">{{'IdentifyProductsWithoutBrand' | translate}}</mat-slide-toggle>
              </div>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                  <mat-label>{{ 'ImportConfigurationDecimalPrecision' | translate }}</mat-label>
                  <mat-select name="DecimalPrecision" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.DecimalPrecision" [disabled]="this.Configuration.AutoDetectDecimalPrecision">
                    <mat-option *ngFor="let d of this.DecimalPrecisions" [value]="d">
                      {{d.Meaning}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle matTooltip="{{ 'AutoDetectDecimalPrecision' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.Configuration.AutoDetectDecimalPrecision">{{'AutoDetectDecimalPrecision' | translate}}</mat-slide-toggle>
              </div>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <mat-label>{{ 'SellPriceCalculationType' | translate }}</mat-label>
                <mat-select name="SellPriceCalculationType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.SellPriceCalculationType">
                  <mat-option *ngFor="let s of this.SellPriceCalculationTypes" [value]="s">
                    <span matTooltip="{{s.Description}}" matTooltipClass='neutral-tool-tip-management'>{{s.Name}}</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
  
              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;" matTooltip="{{ 'DiscountedPriceExplanation' | translate }}" matTooltipClass='neutral-tool-tip-management'>
                <mat-slide-toggle [(ngModel)]="this.Configuration.UseGroupDiscounts">{{'UseGroupDiscounts' | translate}}</mat-slide-toggle>
              </div>
  
              <div class="DiscountGroupContainer">
                <button mat-raised-button color="primary" class="AddNewProductButton" (click)="InitializeNewDiscountGroup();">
                  <i class="material-icons">add</i>
                  {{'NewDiscountGroup' | translate}}
                </button>
                
                <div class="DiscountGroup" *ngFor="let discountGroup of this.Configuration.DiscountedGroups">
                  <mat-form-field appearance="outline" class="ProductPropertyTextBox" style="width: 15%;">
                    <mat-label>{{ 'PurchaseDiscountValue' | translate }}*</mat-label>
                    <input matInput placeholder="{{ 'DiscountValue' | translate }}*" autocomplete="off" [(ngModel)]="discountGroup.DiscountValue">
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="ProductPropertyTextBox" style="width: 15%;">
                    <mat-label>{{ 'SellingDiscountValue' | translate }}*</mat-label>
                    <input matInput placeholder="{{ 'DiscountValue' | translate }}*" autocomplete="off" [(ngModel)]="discountGroup.SellingDiscountValue">
                  </mat-form-field>
                  
                  <mat-form-field appearance="outline" class="ProductPropertyTextBox" style="width: 60%;" *ngIf="discountGroup.IsAnyGroup == false;">
                    <mat-label>{{ 'GroupName' | translate }}*</mat-label>
                    <input matInput placeholder="{{ 'GroupName' | translate }}*" autocomplete="off" [(ngModel)]="discountGroup.GroupName">
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="ProductPropertyTextBox" style="width: 60%;" *ngIf="discountGroup.IsAnyGroup == true;" matTooltip="{{ 'ValidAnyOtherDiscountGroupDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
                    <mat-label>{{ 'GroupName' | translate }}*</mat-label>
                    <input disabled="true" matInput placeholder="{{ 'ValidAnyOtherDiscountGroup' | translate }}*" autocomplete="off">
                  </mat-form-field>
  
                  <i class="material-icons discountGroupControlButton" (click)="OpenDiscountGroupDeleteQuestion(discountGroup);" *ngIf="discountGroup.IsAnyGroup == false;">close</i>
                </div>
              </div>
  
            </div>
    
            <div class="OneThirdColumn">
    
              <div class="ColumnTitle">
                <i class="material-icons">format_list_bulleted</i>
                {{'Indexes' | translate}}
              </div>

              <p class="IndexGroupTitle">{{'ProductsInformation' | translate}}</p>
    
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Brand?.Name?.length > 0;" (click)="this.Configuration.Indexes.Brand = null;">close</i>
                  <mat-label>{{ 'BrandIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.Brand != null" name="BrandIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Brand">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
  
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Name?.Name?.length > 0;" (click)="this.Configuration.Indexes.Name = null;">close</i>
                  <mat-label>{{ 'NameIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.Name != null" name="NameIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Name">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
  
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.PartNumber?.Name?.length > 0;" (click)="this.Configuration.Indexes.PartNumber = null;">close</i>
                <mat-label>{{ 'PartNumberIndex' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.Indexes.PartNumber != null" name="PartNumberIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.PartNumber">
                  <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                    {{p.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
  
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Description?.Name?.length > 0;" (click)="this.Configuration.Indexes.Description = null;">close</i>
                  <mat-label>{{ 'DescriptionIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.Description != null" name="DescriptionIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Description">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <p class="IndexGroupTitle">{{'Commercial' | translate}}</p>
  
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.HSCode?.Name?.length > 0;" (click)="this.Configuration.Indexes.HSCode = null;">close</i>
                  <mat-label>{{ 'HSCodeIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.HSCode != null" name="HSCodeIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.HSCode">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
              
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes?.COO?.Name?.length > 0;" (click)="this.Configuration.Indexes.COO = null;">close</i>
                  <mat-label>{{ 'COOIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.COO != null" name="COOIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.COO">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
  
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.EAN?.Name?.length > 0;" (click)="this.Configuration.Indexes.EAN = null;">close</i>
                  <mat-label>{{ 'EANIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.EAN != null" name="EANIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.EAN">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
  
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.LeadTime?.Name?.length > 0;" (click)="this.Configuration.Indexes.LeadTime = null;">close</i>
                  <mat-label>{{ 'LeadTimeIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.LeadTime != null" name="LeadTimeIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.LeadTime">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.DatasheetLink?.Name?.length > 0;" (click)="this.Configuration.Indexes.DatasheetLink = null;">close</i>
                  <mat-label>{{ 'DatasheetLinkIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.DatasheetLink != null" name="DatasheetLinkIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.DatasheetLink">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
  
              <p class="IndexGroupTitle">{{'PriceAndCurrency' | translate}}</p>

              <div *ngIf="this.Configuration?.MasterDataImportOnly == true">
                <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                  <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Price?.Name?.length > 0;" (click)="this.Configuration.Indexes.Price = null;">close</i>
                    <mat-label>{{ 'ListPrice' | translate }}</mat-label>
                    <mat-select [disabled]="this.Configuration.Indexes.Price != null" name="PriceIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Price">
                      <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                        {{p.Name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
              </div>

              <div *ngIf="this.Configuration?.MasterDataImportOnly != true">
                <div *ngIf="this.Configuration?.SellPriceCalculationType?.ID == 0;">
                  <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                    <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Price?.Name?.length > 0;" (click)="this.Configuration.Indexes.Price = null;">close</i>
                      <mat-label>{{ 'PurchasePrice' | translate }}</mat-label>
                      <mat-select [disabled]="this.Configuration.Indexes.Price != null" name="PriceIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Price">
                        <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                          {{p.Name}}
                        </mat-option>
                      </mat-select>
                  </mat-form-field>
                </div>
  
                <div *ngIf="this.Configuration?.SellPriceCalculationType?.ID == 1;">
                  <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                    <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Price?.Name?.length > 0;" (click)="this.Configuration.Indexes.Price = null;">close</i>
                      <mat-label>{{ 'PurchasePrice' | translate }}</mat-label>
                      <mat-select [disabled]="this.Configuration.Indexes.Price != null" name="PriceIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Price">
                        <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                          {{p.Name}}
                        </mat-option>
                      </mat-select>
                  </mat-form-field>
      
                  <mat-form-field appearance="outline"class="ProductPropertyTextBox" matTooltip="{{ 'DiscountedPriceExplanation' | translate }}" matTooltipClass='neutral-tool-tip-management'>
                    <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.DiscountedPrice?.Name?.length > 0;" (click)="this.Configuration.Indexes.DiscountedPrice = null;">close</i>
                      <mat-label>{{ 'SellPrice' | translate }}</mat-label>
                      <mat-select [disabled]="this.Configuration.Indexes.DiscountedPrice != null" name="DiscountedPriceIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.DiscountedPrice">
                        <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                          {{p.Name}}
                        </mat-option>
                      </mat-select>
                  </mat-form-field>
                </div>
              </div>
  
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Currency?.Name?.length > 0;" (click)="this.Configuration.Indexes.Currency = null;">close</i>
                  <mat-label>{{ 'CurrencyIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.Currency != null" name="CurrencyIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Currency">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
           
              <p class="IndexGroupTitle">{{'StockAndDiscount' | translate}}</p>
  
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.StockQuantity?.Name?.length > 0;" (click)="this.Configuration.Indexes.StockQuantity = null;">close</i>
                  <mat-label>{{ 'StockQuantityIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.StockQuantity != null" name="StockQuantityIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.StockQuantity">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

               <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle [(ngModel)]="this.Configuration.StockPriceCalculatedFromPartnerListPriceOffers">{{'StockPriceCalculatedFromPartnerListPriceOffers' | translate}}</mat-slide-toggle>
              </div>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.ManufacturerStock?.Name?.length > 0;" (click)="this.Configuration.Indexes.ManufacturerStock = null;">close</i>
                  <mat-label>{{ 'ManufacturerStockIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.ManufacturerStock != null" name="ManufacturerStockIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.ManufacturerStock">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="ProductPropertyTextBox" matTooltip="{{ 'ManufacturerStockLeadTimeUnitsDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
                <mat-label>{{ 'ManufacturerStockLeadTimeUnits' | translate }}</mat-label>
                <input matInput name="ManufacturerStockLeadTimeUnits"
                  inputmode="numeric"
                  autocomplete="off"
                  [(ngModel)]="this.Configuration.ManufacturerStockLeadTime.Units"
                  (keydown)="digitKeydown($event)"
                  (paste)="digitPaste($event)"
                  (drop)="digitDrop($event)"
                  (input)="digitSanitizeMin0($event)"
                  (wheel)="digitWheel($event)"/>
              </mat-form-field>

              <mat-form-field appearance="outline" class="ProductPropertyTextBox" matTooltip="{{ 'ManufacturerStockLeadTimeTypeDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.ManufacturerStockLeadTime?.Type?.Name?.length > 0;" (click)="this.Configuration.ManufacturerStockLeadTime.Type = null;">close</i>
                <mat-label>{{ 'ManufacturerStockLeadTimeType' | translate }}</mat-label>
                <mat-select [disabled]="this.Configuration.ManufacturerStockLeadTime?.Type != null" name="ManufacturerStockLeadTimeType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Configuration.ManufacturerStockLeadTime.Type">
                  <mat-option *ngFor="let t of this.LeadTimeTypes" [value]="t">
                    {{t.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle [(ngModel)]="this.Configuration.UseManufacturerStockLeadTime">{{'UseManufacturerStockLeadTime' | translate}}</mat-slide-toggle>
              </div>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.DiscountGroup?.Name?.length > 0;" (click)="this.Configuration.Indexes.DiscountGroup = null;">close</i>
                  <mat-label>{{ 'DiscountGroupIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.DiscountGroup != null" name="DiscountGroupIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.DiscountGroup">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <p class="IndexGroupTitle">{{'DimentionsAndWeight' | translate}}</p>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.Weight?.Name?.length > 0;" (click)="this.Configuration.Indexes.Weight = null;">close</i>
                  <mat-label>{{ 'WeightIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.Weight != null" name="WeightIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.Weight">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
  
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.WeightType?.Name?.length > 0;" (click)="this.Configuration.Indexes.WeightType = null;">close</i>
                  <mat-label>{{ 'WeightTypeIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.WeightType != null" name="WeightTypeIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.WeightType">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.ProductLength?.Name?.length > 0;" (click)="this.Configuration.Indexes.ProductLength = null;">close</i>
                  <mat-label>{{ 'ProductLength' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.ProductLength != null" name="ProductLengthIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.ProductLength">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>
              
              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.ProductWidth?.Name?.length > 0;" (click)="this.Configuration.Indexes.ProductWidth = null;">close</i>
                  <mat-label>{{ 'ProductWidth' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.ProductWidth != null" name="ProductWidthIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.ProductWidth">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.ProductHeight?.Name?.length > 0;" (click)="this.Configuration.Indexes.ProductHeight = null;">close</i>
                  <mat-label>{{ 'ProductHeight' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.ProductHeight != null" name="ProductHeightIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.ProductHeight">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <p class="IndexGroupTitle">{{'Settings' | translate}}</p>

              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle [(ngModel)]="this.Configuration.BrandETAMainList" matTooltip="{{ 'BrandETAMainListDescription' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'BrandETAMainList' | translate}}</mat-slide-toggle>
              </div>

              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle matTooltip="{{ 'PrioritizeHistoryPriceDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.Configuration.PrioritizeHistoryPrice">{{'PrioritizeHistoryPrice' | translate}}</mat-slide-toggle>
              </div>

              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle [disabled]="!this.Configuration.PrioritizeHistoryPrice" matTooltip="{{ 'CompareHistoryPriceWithListPriceDesc' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.Configuration.CompareHistoryPriceWithListPrice">{{'CompareHistoryPriceWithListPrice' | translate}}</mat-slide-toggle>
              </div>

              <mat-form-field appearance="outline"class="ProductPropertyTextBox">
                <i style="color: red;" class="material-icons BrandSelectCloseIcon" *ngIf="this.Configuration.Indexes.MOQ?.Name?.length > 0;" (click)="this.Configuration.Indexes.MOQ = null;">close</i>
                  <mat-label>{{ 'MOQIndex' | translate }}</mat-label>
                  <mat-select [disabled]="this.Configuration.Indexes.MOQ != null" name="MOQIndex" [compareWith]="this.comparePosition" [(ngModel)]="this.Configuration.Indexes.MOQ">
                    <mat-option *ngFor="let p of this.ConfigurationPositions" [value]="p">
                      {{p.Name}}
                    </mat-option>
                  </mat-select>
              </mat-form-field>

              <div class="ProductPropertyTextBox" style="margin-bottom: 15px;">
                <mat-slide-toggle matTooltip="{{ 'MOQAdjustmentDescription' | translate }}" matTooltipClass='neutral-tool-tip-management' [(ngModel)]="this.Configuration.MOQAdjustment">{{'MOQAdjustment' | translate}}</mat-slide-toggle>
              </div>
  
            </div>
          </div>
          <div class="NewProductContainerCommands">
            <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Configuration.ID == 0;" (click)="AddUpdateImportConfiguration();">
              <i class="material-icons">add</i>
              {{'NewConfiguration' | translate}}
            </button>
    
            <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Configuration.ID > 0;" (click)="AddUpdateImportConfiguration();">
              <i class="material-icons">edit</i>
              {{'ModifyConfiguration' | translate}}
            </button>

            <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Configuration.ID > 0;" (click)="OpenDeleteConfigurationOffers();">
              <i class="material-icons">edit</i>
              {{'DeleteConfigurationOffers' | translate}}
            </button>

            <!-- <button mat-raised-button color="accent" class="GroupDiscountsUpdateButton" *ngIf="this.Configuration.ID > 0 && this.Configuration.UseGroupDiscounts == true;" (click)="OpenUpdateGroupDiscountsData();">
              <i class="material-icons">downloading</i>
              {{'UpdateGroupDiscountsData' | translate}}
            </button> -->

            <div class="NewProductContainerCommandsInfoContainer">
              <mat-spinner class="CommandsInfoContainerSpinner" [diameter]="20" *ngIf="this.loadingCount == true;"></mat-spinner>
              <span *ngIf="this.loadingCount == false;">({{this.Configuration.TotalDBOffers}} {{'Offers' | translate}})</span>
            </div>
            <div class="NewProductContainerCommandsInfoContainer">
              <span>{{'LastImport' | translate}}: {{this.Configuration.LastImportUI}}</span>
            </div>
            <div class="NewProductContainerCommandsInfoContainer">
              <span style="background: #4d148c;">{{'ServerFileLastUpdate' | translate}}: {{this.Configuration.ServerPathFileEventRegisterUI}}</span>
            </div>
          </div>
        </div>
    </div>
  </div>